import QuemSomos from '../components/QuemSomos';

const Sobre = () => {
  return (
    <div className="" id="quem-somos">
      <QuemSomos />
    </div>
    // {/* </section> */}
  );
};

export default Sobre;
